import UserStatusService from "./UserStatusService"
export default UserStatusService
